/** @jsx jsx */
import { jsx } from "theme-ui"
import SanityBlockContent from "@sanity/block-content-to-react"
import { merge } from "lodash"

import {
  Image,
  Embed,
  Link,
  EmailLink,
  FileLink,
  Container,
} from "./sanityBlocks"

const serializers = {
  types: {
    embed: Embed,
    imageWithCredits: Image,
  },
  marks: {
    link: Link,
    emailLink: EmailLink,
    fileLink: FileLink,
  },
  container: Container,
}

export default function BlockContent({
  serializers: serializersProp,
  ...otherProps
}) {
  return (
    <SanityBlockContent
      serializers={merge({}, serializers, serializersProp)}
      renderContainerOnSingleChild
      {...otherProps}
    />
  )
}
